import { CRMCountryData, MarketInsightsRequest } from '../../hooks/queries';
import { MarketInsight } from '../types';
import { principalServiceRequest } from './base-request';

export async function getCountriesInformation() {
  const { data } = await principalServiceRequest<{
    items: CRMCountryData[];
  }>('get', 'principals/countries');
  return data;
}

export async function getCRMMarketInsights({
  principalId,
  filters,
  sortOrder,
}: MarketInsightsRequest) {
  const {
    data: { items },
  } = await principalServiceRequest<{
    items: MarketInsight[];
  }>('get', `principals/${principalId}/market-insights`, undefined, {
    ...(Array.isArray(filters?.countries)
      ? {
          countries: filters?.countries?.map((c) => c.iso).join(','),
        }
      : null),
    ...(Array.isArray(filters?.marketSegments)
      ? {
          marketSegments:
            filters?.marketSegments
              .map((m) => m.name)
              .filter((s) => s !== undefined)
              .join(',') ?? null,
        }
      : null),
    ...(Array.isArray(filters?.categories) &&
    filters?.categories?.length &&
    filters?.categories?.length > 0
      ? {
          categories: filters.categories.map((c) => c.name).join(','),
        }
      : null),
    ...(filters?.maxAgeInDays && { maxAgeInDays: filters.maxAgeInDays }),
    ...(sortOrder && { order: sortOrder }),
  });

  return items;
}

export async function getMarketInsightCategories(principalId: string) {
  const {
    data: { items },
  } = await principalServiceRequest<{
    items: { id: string; name: string }[];
  }>('get', `principals/${principalId}/market-insights/categories`);

  return items;
}
